module.exports= [
    {
        id: 1,
        label: '污水污泥饲料',
        children: [{
            id: '/index',
            label: '污水污泥',
        },{
            id: '/siliao',
            label: '饲料',
        }]
    },
    {
        id: 2,
        label: '司机审核',
        children: [{
            id: '/shenhe',
            label: '污水污泥司机审核',
        },{
            id: '/shenhe2',
            label: '饲料司机审核',
        }]
    },
    {
        id: 3,
        label: '环保',
        children: [{
            id: '/huanbaoadmin',
            label: '环保',
        }]
    },
    {
        id: 4,
        label: '油耗',
        children: [{
            id: '/cladmin',
            label: '车辆用油',
        },{
            id: '/yhdb',
            label: '油耗核销',
        },{
            id: '/clnsadmin',
            label: '车用尿素',
        },{
            id: '/scadmin',
            label: '生产领用',
        },{
            id: '/qtadmin',
            label: '其他用油',
        },{
            id: '/kucun',
            label: '油量库存',
        }]
    },
    {
        id: 5,
        label: '死猪',
        children: [{
            id: '/sizhuadmin',
            label: '死猪',
        }]
    },
    {
        id: 6,
        label: '行驶记录',
        children: [{
            id: '/xsjladmin',
            label: '行驶记录',
        }]
    },
    {
        id: 7,
        label: '猪粪运载',
        children: [{
            id: '/zfyzadmin',
            label: '猪粪运载',
        }]
    },

    {
        id: 8,
        label: '投诉反馈',
        children: [{
            id: '/tousufankui',
            label: '投诉反馈',
        }]
    },

    {
        id: 10,
        label: '食堂评选',
        children: [{
            id: '/shitang11',
            label: '菜单评选',
        },{
            id: '/shitang12',
            label: '菜单留言',
        },{
            id: '/shitang13',
            label: '物资评选',
        },{
            id: '/shitangpf',
            label: '满意度调查',
        },]
    },

    {
        id: 11,
        label: '股东回馈',
        children: [{
            id: '/gdhk1',
            label: '机构持股',
        },{
            id: '/gdhk2',
            label: '个人持股',
        },]
    },

    {
        id: 9,
        label: '系统维护',
        children: [{
            id: '/carlist',
            label: '车辆维护',
        },{
            id: '/wages.vue',
            label: '工资维护',
        },{
            id: '/yklist',
            label: '油卡维护',
        },{
            id: '/yklist2',
            label: '主卡维护',
        },{
            id: '/khadmin',
            label: '客户维护',
        },{
            id: '/useradmin',
            label: '管理员维护',
        },{
            id: '/power',
            label: '权限维护',
        }]
    },
]



